<p-multiselect
  [options]="languageOptions"
  [(ngModel)]="selectedOptions"
  [filter]="true"
  [showToggleAll]="false"
  placeholder="{{ 'language.multiselect.select' | transloco }}"
  (ngModelChange)="onSelectionChange()"
  optionLabel="label"
  display="chip"
  appendTo="body"
  [style]="{maxWidth: '100%'}"
  [attr.data-testid]="'filter-languages-dropdown'"
>
</p-multiselect>
